<script>
import EmailUpdate from '@app/components/Admin/EmailUpdate.vue';
import CertificateCleaner from '@app/components/Admin/CertificateCleaner.vue';
import PaymentProviderDisconnect from '@app/components/Admin/PaymentProviderDisconnect.vue';
import DisableTab from '@app/components/Admin/DisableTab.vue';
// import DomainProvision from '@app/components/Admin/DomainProvision.vue';

export default {
  components: {
    DisableTab,
    PaymentProviderDisconnect,
    CertificateCleaner,
    EmailUpdate,
    // DomainProvision,
  },
};
</script>

<template>
  <section>

    <header class="level">
      <div class="level-left is-block w-60p">
        <h1 class="title is-size-4-mobile mb-2">
          Opérations d'administration
        </h1>
        <hr>
        <EmailUpdate/>
        <!-- Utilisation du composant générique pour Stripe -->
        <PaymentProviderDisconnect
          providerName="Stripe"
          apiMethod="disconnectStripe"
        />
        <!-- Utilisation du même composant générique pour PayPal -->
        <PaymentProviderDisconnect
          providerName="PayPal"
          apiMethod="disconnectPaypal"
        />
        <CertificateCleaner/>
        <DisableTab/>
<!--        <DomainProvision/>-->
      </div>
    </header>
  </section>
</template>
